import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import * as coreBi from '#packages/coreBi';
import * as util from '#packages/util';
import { translate } from '#packages/i18n';

import * as symbols from '@wix/santa-editor-symbols';
import * as baseUI from '#packages/baseUI';
import {
  Button,
  ContextMenu,
  ContextMenuAction,
  ContextMenuContent,
  Divider,
  Preloader,
  TextInput,
  Tooltip,
  TooltipOnEllipsis,
} from '@wix/wix-base-ui';
import { cx, isCustomMenusEnabled } from '#packages/util';
import constants from '#packages/constants';
import { getPagesMenuItemSymbol, getMenuItemBiType } from '../../../utils';
import { TriggerSources } from '#packages/pages';

const itemTypeSymbolSize = 20;

function getActionSymbol(action: AnyFixMe) {
  if (action?.symbol) {
    return <action.symbol className="symbol" />;
  }
  if (action?.symbolName) {
    return <symbols.symbol name={action.symbolName} />;
  }
  return null;
}

function renderAction(action: AnyFixMe, { handleClickAction }: AnyFixMe) {
  if (action.isDivider) {
    return null; //<baseUILib.Divider key={action.key} />;
  }

  const isSetting = action.isSettings;
  const className = isSetting
    ? 'menu-item-settings-action-pp'
    : `action-${action.title}`;
  const handleClick = () => handleClickAction(action, { isSetting });
  const key = `action-${action.title}-${action.folderId || ''}`;

  return (
    <ContextMenuAction
      onClick={handleClick}
      key={key}
      disabled={action.disabled}
      automationId={`action-${action.title}`}
      className={className}
    >
      {getActionSymbol(action)}
      {action.tooltipText ? (
        <Tooltip
          // @ts-expect-error
          alignment={constants.UI.TOOLTIP.ALIGNMENT.RIGHT}
          shouldTranslate={false}
          key="tooltip"
          content={action.tooltipText}
        >
          <span>{action.title}</span>
        </Tooltip>
      ) : (
        <span>{action.title}</span>
      )}
    </ContextMenuAction>
  );
}

function getShouldShowLoader(
  dataSource: AnyFixMe,
  loadingPageId: AnyFixMe,
  loadingTrigger: AnyFixMe,
) {
  const isTriggeredInMenu = loadingTrigger?.source === TriggerSources.MENU_ITEM;
  if (!isTriggeredInMenu) return false;

  const menuItemType = dataSource?.type?.raw;

  switch (menuItemType) {
    case 'PageLink':
      const pageId = dataSource?.pageData?.id;
      const isTriggeredByNonePageItem = !!loadingTrigger?.nonePageId;
      const isCurrentPageLoading = loadingPageId === pageId;

      return isCurrentPageLoading && !isTriggeredByNonePageItem;
    case 'DynamicPageLink':
      const dynamicPageRouteId = dataSource?.link?.routerId;

      return loadingPageId === dynamicPageRouteId;
    case 'AnchorLink':
      const doesItemLinkToPage =
        dataSource?.link?.pageId?.includes(loadingPageId);
      const isTriggeredByCurrentItem =
        dataSource?.id === loadingTrigger?.nonePageId;

      return doesItemLinkToPage && isTriggeredByCurrentItem;
    default:
      return false;
  }
}

function template() {
  // @ts-expect-error
  const that = this as AnyFixMe;
  const shouldShowLoader = getShouldShowLoader(
    that.props.dataSource,
    that.props.loadingPageId,
    that.props.loadingTrigger,
  );

  return (
    <div
      onClick={that.handleClickItem}
      data-aitemtype={that.getAutomationItemType()}
      className={cx('menu-item-pp', that.getTopLevelClasses())}
    >
      {that.state.inputValue === null
        ? (() => {
            const pagePermissionSymbol = that.getPagePermissionSymbol();

            return (
              <div
                key="pageInfo"
                onDoubleClick={that.onDoubleClick}
                className="title-action-container"
              >
                <div className="left-container">
                  {that.props.isDragAvailable ? (
                    <symbols.symbol
                      name="dragPage"
                      key="drag-icon"
                      className="page-item-drag"
                    />
                  ) : null}
                  <Tooltip
                    disabled={!that.props.info}
                    content={that.props.info}
                    shouldTranslate={false}
                    // @ts-expect-error
                    arrowAlignment="top"
                    key="tooltip-type-symbol-pp"
                  >
                    {shouldShowLoader ? (
                      <div className="menu-item-loader">
                        <Preloader className="tiny dark" />
                      </div>
                    ) : (
                      <baseUI.SymbolWrapper
                        name={that.getTypeSymbolName()}
                        size={itemTypeSymbolSize}
                        className="symbol"
                      />
                    )}
                  </Tooltip>
                  <span className={cx(that.getTitleClass())}>
                    <TooltipOnEllipsis
                      marginTop={5}
                      contentClassName="menu-item-title-name"
                    >
                      {that.props.dataSource.label}
                    </TooltipOnEllipsis>
                  </span>
                </div>
                <div className="right-container">
                  {pagePermissionSymbol ? (
                    <symbols.symbol
                      name={pagePermissionSymbol}
                      key="pagePermissionSymbol"
                    />
                  ) : null}
                  {that.isHidden() ? (
                    <symbols.symbol
                      name="hiddenPageStatus"
                      key="hiddenPageStatus-symbol"
                    />
                  ) : null}
                  {that.state.actions
                    ? (() => {
                        const actions = that.filterRegularActions();
                        const dataBindingActions =
                          that.filterDataBindingActions();
                        const tools = that.filterToolsActions();
                        const settings = that.filterSettingsActions();

                        return (
                          <div onContextMenu={that.handleRightClickOnMenu}>
                            <ContextMenu
                              isOpen={that.state.contextMenuOpened}
                              onToggle={that.handleContextMenuToggle}
                              automationId="menu-item-context-menu"
                              className="flat menu-item-context-menu-button"
                              maxWidth={'400px'}
                            >
                              <ContextMenuContent
                                key={`actions-${that.state.actions.length}`}
                              >
                                {settings.map((action: AnyFixMe) =>
                                  renderAction(action, {
                                    handleClickAction: that.handleClickAction,
                                  }),
                                )}

                                {!_.isEmpty(tools) ? (
                                  <Divider key="actions-divider-1" />
                                ) : null}

                                {tools.map((action: AnyFixMe) =>
                                  renderAction(action, {
                                    handleClickAction: that.handleClickAction,
                                  }),
                                )}

                                {!_.isEmpty(dataBindingActions) ? (
                                  <Divider key="actions-divider-2" />
                                ) : null}

                                {dataBindingActions.map((action: AnyFixMe) =>
                                  renderAction(action, {
                                    handleClickAction: that.handleClickAction,
                                  }),
                                )}

                                {!_.isEmpty(actions) && !_.isEmpty(settings) ? (
                                  <Divider key="actions-divider-3" />
                                ) : null}

                                {actions.map((action: AnyFixMe) =>
                                  renderAction(action, {
                                    handleClickAction: that.handleClickAction,
                                  }),
                                )}
                              </ContextMenuContent>
                            </ContextMenu>
                          </div>
                        );
                      })()
                    : null}
                </div>
              </div>
            );
          })()
        : null}
      {that.state.inputValue !== null
        ? (() => {
            const validationInvalidMsg = that.getValidationInvalidMsg();

            return (
              <div
                onMouseDown={(e) => {
                  e.stopPropagation();
                }}
                key="input-container-page-pp"
                className="input-button-container"
              >
                <TextInput
                  value={that.state.inputValue}
                  onChange={that.handleChangeInput}
                  isValid={!validationInvalidMsg}
                  invalidMessage={validationInvalidMsg}
                  shouldTranslate={false}
                  selectOnFocus={true}
                  maxLength={40}
                  onBlur={that.handleRenameDone}
                  autoSelect={true}
                  placeholder={that.getPlaceholder()}
                  dataHook="rename-menu-item-input"
                />
                <Button
                  dataHook="confirm-rename-page-button"
                  disabled={validationInvalidMsg}
                  className="done-button"
                >
                  {that.getRenameButtonLabel()}
                </Button>
              </div>
            );
          })()
        : null}
    </div>
  );
}

class MenuItem extends React.Component<AnyFixMe, AnyFixMe> {
  constructor(props: AnyFixMe) {
    super(props);

    const that = this as AnyFixMe;

    that.state = {
      actions: that.props.initialActions,
      contextMenuOpened: false,
      inputValue: (() => {
        const renamedMenuItem =
          that.props.dataSource.id === that.props.renamedMenuItemId;
        if (!renamedMenuItem || !that.props.renameEnabled) {
          return null;
        }

        if (typeof that.props.setDropdownPlaceholderVisibility === 'function') {
          that.props.setDropdownPlaceholderVisibility(false);
        }

        const actions = that.props.getMenuItemActions(that.props.dataSource);
        // TODO: Fix that the next time the file is edited.
        // eslint-disable-next-line you-dont-need-lodash-underscore/filter
        const renameAction = _.head(_.filter(actions, 'isRename'));
        return renameAction ? that.props.dataSource.label : null;
      })(),
    };

    that.handleClickAction = (
      action: AnyFixMe,
      { isSetting }: AnyFixMe = {},
    ) => {
      if (isSetting) {
        that.props.setSelected();
      }
      if (action.isRename) {
        that.openRenameMode('quick_actions_menu');
      } else {
        action.onClick(that.props.dataSource.id, that.props.dataSource.label);
      }
    };
    that.handleClickItem = (event: AnyFixMe) => {
      // Check whether it was click on context menu or item iteself
      const CONTEXT_MENU_SELECTOR = '.menu-item-context-menu-button';
      if (event.target.closest(CONTEXT_MENU_SELECTOR)) {
        return;
      }

      that.props.setSelected();

      const nonePageId = that.props.dataSource?.type?.isLink
        ? that.props.dataSource?.id
        : undefined;

      that.props.setLoadingTrigger?.(nonePageId);
    };
    that.openRenameMode = (actionSourceType: AnyFixMe) => {
      const renameAction = that.getRenameAction();

      if (renameAction && that.props.renameEnabled) {
        that.actionSourceType = actionSourceType;
        that.setState({ inputValue: that.props.dataSource.label });
      }
    };
    that.handleChangeInput = (inputValue: AnyFixMe) =>
      that.setState({ inputValue });
    that.handleRenameDone = () => {
      const isValid = !util.validate.pageNameValidator(that.state.inputValue);
      const renamedValue = isValid
        ? that.state.inputValue
        : that.props.dataSource.label;

      const renameAction = that.getRenameAction();
      renameAction.onClick(
        that.props.dataSource.id,
        renamedValue,
        'rename',
        that.actionSourceType || 'right-click-context-menu',
      );

      if (typeof that.props.setDropdownPlaceholderVisibility === 'function') {
        that.props.setDropdownPlaceholderVisibility(true);
      }
      that.props.setSelected();
      that.setState({ inputValue: null, contextMenuOpened: false });
      delete that.actionSourceType;
    };
    that.getRenameAction = () => {
      let { actions } = that.state;
      if (_.isEmpty(actions)) {
        actions = that.props.getMenuItemActions(that.props.dataSource);
      }

      // TODO: Fix that the next time the file is edited.
      // eslint-disable-next-line you-dont-need-lodash-underscore/filter
      return _.head(_.filter(actions, 'isRename'));
    };

    that.onDoubleClick = () => that.openRenameMode('double_click');

    that.handleRightClickOnMenu = (e: AnyFixMe) => {
      e.preventDefault();
      e.stopPropagation();
    };

    that.handleContextMenuToggle = (actionsOpened: AnyFixMe) => {
      if (actionsOpened) {
        that.setState({
          contextMenuOpened: true,
          actions: that.getActionsForItem(that.props.dataSource),
        });

        that.props.biEvent(coreBi.events.pages.pagesPanel.page_actions_click, {
          page_id:
            that.props.dataSource?.pageData?.id ||
            that.props.dataSource?.link?.pageId,
          source: that.props.biCategory,
          type: getMenuItemBiType(that.props.dataSource),
        });
      } else {
        that.setState({
          contextMenuOpened: false,
          actions: [],
        });
      }
    };

    that.getActionsForItem = (menuItem: AnyFixMe) =>
      that.props.getMenuItemActions(menuItem);

    that.isHidden = () => {
      if (isCustomMenusEnabled()) {
        return false;
      }

      if (that.props.isMobile) {
        return !that.props.dataSource.isVisibleMobile;
      }
      return !that.props.dataSource.isVisible;
    };

    that.getAutomationItemType = () => {
      const menuItem = that.props.dataSource;
      const prefix = menuItem.parent ? 'subpage-' : '';

      if (menuItem.isHomePage) {
        return `${prefix}home`;
      }
      if (menuItem.type.isPage) {
        return `${prefix}page`;
      }
      if (menuItem.type.isLink) {
        return `${prefix}link`;
      }
      if (menuItem.type.isDropdown) {
        return `${prefix}folder`;
      }
    };

    that.getTopLevelClasses = () => ({
      'hidden-page': that.isHidden(),
      selected: that.props.isSelected,
      'show-context-menu-button': that.state.contextMenuOpened,
    });

    that.getPagePermissionSymbol = () => {
      const isMembersPermission =
        that.props.dataSource?.pageData?.pageSecurity?.requireLogin;
      if (isMembersPermission) {
        return 'membersPagePermission';
      }
      const isPasswordPermission =
        that.props.dataSource?.pageData?.pageSecurity?.dialogLanguage;
      if (isPasswordPermission) {
        return 'passwordPagePermission';
      }
      return null;
    };

    that.getTitleClass = () => {
      const hasAttribute = !!that.getPagePermissionSymbol();
      const isHidden = !!that.isHidden();
      const isSubpage = !!that.props.dataSource.parent;

      return {
        'menu-item-title': true,
        'page-without-attributes': !isSubpage && !hasAttribute && !isHidden,
        'subpage-without-attributes': isSubpage && !hasAttribute && !isHidden,
        'page-with-attribute':
          (!isSubpage && hasAttribute && !isHidden) ||
          (!isSubpage && !hasAttribute && isHidden),
        'subpage-with-attribute':
          (isSubpage && hasAttribute && !isHidden) ||
          (isSubpage && !hasAttribute && isHidden),
        'page-with-attributes': !isSubpage && hasAttribute && isHidden,
        'subpage-with-attributes': isSubpage && hasAttribute && isHidden,
      };
    };

    that.filterSettingsActions = () =>
      (that.state.actions || []).filter(
        (action: AnyFixMe) => action.isSettings,
      );
    that.filterRegularActions = () =>
      (that.state.actions || []).filter(
        (action: AnyFixMe) =>
          !action.isSettings && !action.isTools && !action.isCmsAction,
      );
    that.filterToolsActions = () =>
      (that.state.actions || []).filter((action: AnyFixMe) => action.isTools);
    that.filterDataBindingActions = () =>
      (that.state.actions || []).filter(
        (action: AnyFixMe) => action.isCmsAction,
      );
    that.getTypeSymbolName = () => {
      const data = that.props.dataSource;
      const pageAppDefId = data.pageData?.managingAppDefId;
      const pageId = data.pageData?.id;

      const pageAppData = that.props.appPages?.find(
        (element: AnyFixMe) => element.id === pageAppDefId,
      );
      const page = pageAppData?.pagesData.find(
        (page: any) => page.id === pageId,
      );
      const pageIcon = page?.pageDescriptor?.icon;
      return pageIcon ?? getPagesMenuItemSymbol(data);
    };

    that.getRenameButtonLabel = () => {
      const menuItem = that.props.dataSource;

      if (isCustomMenusEnabled() && menuItem.type.isDropdown) {
        return translate('PagesPanel_Actions_Folder_Rename_Done');
      }

      return translate('Pages_Actions_Rename_Button');
    };
    that.getPlaceholder = () => {
      const menuItem = that.props.dataSource;

      if (isCustomMenusEnabled()) {
        if (menuItem.type.isDropdown) {
          return translate('PagesPanel_Actions_Folder_Placeholder_Text');
        }

        return translate('Pages_Actions_Rename_Placeholder');
      }

      return undefined;
    };

    that.getValidationInvalidMsg = () => {
      const menuItem = that.props.dataSource;
      let validator = util.validate.pageNameValidator;

      if (isCustomMenusEnabled() && menuItem.type.isDropdown) {
        validator = util.validate.pagesFolderNameValidator;
      }

      return translate(validator(that.state.inputValue));
    };
  }

  UNSAFE_componentWillReceiveProps({
    dataSource,
    renamedMenuItemId,
  }: AnyFixMe) {
    const that = this as AnyFixMe;
    const alreadyInTheRenameMode = that.state.inputValue !== null;
    if (dataSource.id === renamedMenuItemId && !alreadyInTheRenameMode) {
      that.openRenameMode();
    }
  }

  render() {
    return template.call(this);
  }
}

// @ts-expect-error
MenuItem.displayName = 'MenuItem';
// @ts-expect-error
MenuItem.propTypes = {
  renamedMenuItemId: PropTypes.string,
  dataSource: PropTypes.object.isRequired,
  isSelected: PropTypes.bool,
  setSelected: PropTypes.func.isRequired,
  isDragAvailable: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
  info: PropTypes.string,
  getMenuItemActions: PropTypes.func.isRequired,
  renameEnabled: PropTypes.bool,
  biEvent: PropTypes.func.isRequired,
  biCategory: PropTypes.string.isRequired,
  initialActions: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  loadingPageId: PropTypes.string,
  loadingTrigger: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  setLoadingTrigger: PropTypes.func,
};

export default MenuItem;
